export const stepStyle = {
    textAlign: 'center'
};

export const labelStyle = {
    position: 'relative',
    fontFamily: 'Roboto',
    zIndex: 10,
    top: 5
};

export const currentStepLabelStyle = {
    ...labelStyle,
    color: '#000000',
    fontSize: 16,
    fontWeight: 'bold',
    userSelect: 'none'
};

export const onwardStepLabelStyle = {
    ...labelStyle,
    color: '#414141',
    fontSize: 15,
    fontWeight: 500,
    userSelect: 'none'
};

export const editedStepStyle = {
    fill: '#FDF1D6',
    stroke: '#FFB50C'
};

export const currentStepStyle = {
    fill: '#FAA800',
    stroke: '#FAA800'
};

export const disabledStepStyle = {
    fill: '#CCCCCC',
    stroke: '#A6A6A6'
};

export const uneditedStepStyle = {
    fill: '#FFFFFF',
    stroke: '#A6A6A6'
};

export const journeyBarContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: 1860
};

export const emptyJourneyBarStyle = {
    width: '100%'
};
